import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { desicreate, desidelete, desilist, desiupdate, desivalidate, desiview } from '../../../services/master';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

export const Designation = () => {
    const navigate = useNavigate();
    const [fdesi, setFDesi] = useState("");
    const [fbid, setFBid] = useState("");
    const [errmsg, setErrMsg] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);
  const role = localStorage.getItem("Role");

    const columnDefs = [

        {
            headerName: "Designation",
            field: "designation_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
         ...(role == 1
      ? [
         {
            headerName: "Status",
            width: 150,
            field: "active",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <label className="custom-switch mb-0">
                            <input
                                type="checkbox"
                                name="custom-switch-checkbox"
                                className="custom-switch-input"
                                checked={params.value == 1 ? true : false}
                                onChange={() => handleSwitch(params)}
                            />

                            <span className="custom-switch-indicator"></span>
                        </label>
                    </div>
                );
            },
        },
        {
            headerName: "Actions",
            field: "id",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() =>
                                viewshow(params.value)
                            }
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fa fa-edit"></i>
                        </a>


                    </div>
                );
            },
        },
      ]
      : []),
      
    ];

    function viewshow(vid) {
        setFBid(vid);
        setFDesi("");
        setShow(true);

        setErrMsg("");
        desiview(vid).then((response) => {
            if (response.status === true) {
                setFDesi(response.data.designation_name);
            }
        });
    }
    useEffect(() => {
        funlist();
    }, []);

    function funlist() {
        setFilterProduct([]);
        desilist().then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }

    const [show, setShow] = useState(false);
    function handleShow() {
        setFBid("");
        setFDesi("");
        setErrMsg("");
        setShow(true);
    }

    function handleclose() {
        setShow(false);
        setFBid("");
        setFDesi("");
        setErrMsg("");
    }

    function handlebranch(e) {
        e.preventDefault();
        setErrMsg("");
        if (fdesi !== "") {
            const temp = new FormData();
            temp.append("name", fdesi);
            temp.append("id", fbid);

            desivalidate(temp).then((response) => {
                if (response.status === false) {
                    setErrMsg(response.message);
                } else {
                    const tempData = new FormData();
                    tempData.append("name", fdesi);
                    if (fbid === "") {
                        desicreate(tempData).then((response) => {
                            if (response.status === true) {
                                handleclose();
                                funlist();
                                toast.success(response.message);
                            } else {
                                setErrMsg(response.data.message);
                            }
                        });
                    } else {
                        tempData.append("id", fbid);
                        desiupdate(tempData).then((response) => {
                            if (response.status === true) {
                                handleclose();
                                funlist();
                                toast.success(response.message);
                            } else {
                                setErrMsg(response.data.message);
                            }
                        });
                    }
                }
            });
        } else {
            setErrMsg("Please Enter Designation");
        }
    }


      function handleSwitch(list) {
            if (list.value == 1) {
                Swal.fire({
                    text: "Are you sure want to Inactive?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ac0404",
                    cancelButtonColor: "#6259ca",
                    confirmButtonText: "Inactive",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const temp = new FormData();
                        temp.append("id", list.data.id);
                        temp.append("status", 0);
    
                        desidelete(temp).then((response) => {
                            if (response.status === true) {
                                funlist();
                            }
                        });
                    }
                });
            } else {
                Swal.fire({
                    text: "Are you sure want to Active?",
                    icon: "success",
                    showCancelButton: true,
                    confirmButtonColor: "#008000",
                    cancelButtonColor: "#6259ca",
                    confirmButtonText: "Active",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const temp = new FormData();
                        temp.append("id", list.data.id);
                        temp.append("status", 1);
    
                        desidelete(temp).then((response) => {
                            if (response.status === true) {
                                funlist();
                            }
                        });
                    }
                });
            }
        }
    

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Designation</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Designation
                    </li>
                </ol>
            </div>
            <div className='d-flex justify-content-end'>
                <a className='btn btn-success' onClick={handleShow}>Add Designation</a>
            </div>
            <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                />
            </div>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header>
                    <h4>{fbid ? "Designation Detail" : "Add Designation"}</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Designation <span className="text-danger"> *</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Designation"
                                    value={fdesi}
                                    onChange={(e) => setFDesi(e.target.value)}
                                />
                            </div>
                        </div>
                        {errmsg && <span className='text-danger'>{errmsg}</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className='btn btn-success' onClick={handlebranch}>{fbid ? "Update" : "Submit"}</a>
                    <a className='btn btn-info' onClick={() => setShow(false)}>Close</a>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
